const messages = {
  namespaced: true,
  state: {
    messages: [],
  },
  mutations: {
    setMessage(state, payload) {
      if (state.messages.length > 20) {
        state.messages.pop();
      }

      state.messages.push(payload);
    },
    setMessages(state, payload) {
      state.messages = payload;
    },
  },
  actions: {},
  getters: {},
};

export default messages;
